/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */
import { FlexContainer, Text, theme } from "@nordcloud/gnui";
import { BarChart } from "~/components";

type Props = {
  startLabel?: string;
  value: number;
  benefit: number;
  endLabel?: string;
  forecast?: number;
};

function getBarColor(benefit: number, palette = 1) {
  if (benefit < 0) {
    return theme.colors.statusDanger[palette];
  }
  return theme.colors.statusSuccess[palette];
}

// Old version of bar color calculation, probably to remove if forecast won't be used.
function getForecastBarColor(value: number, palette = 1) {
  if (value < 20) {
    return theme.colors.statusDanger[palette];
  }
  if (value >= 20 && value <= 80) {
    return theme.colors.statusWarning[palette];
  }
  if (value > 80) {
    return theme.colors.statusSuccess[palette];
  }

  return theme.colors.statusDanger[palette];
}

function getValues(value: number, benefit: number, forecast?: number) {
  if (forecast !== undefined) {
    return [
      {
        color: getForecastBarColor(value),
        value,
      },
      {
        color: getForecastBarColor(value, 0),
        value: forecast - value,
      },
      {
        color: theme.color.support.greyInverse,
        value: 100 - forecast,
      },
    ];
  }

  return [
    {
      color: getBarColor(benefit),
      value,
    },
    {
      color: theme.color.support.greyInverse,
      value: 100 - value,
    },
  ];
}

export function BarProgressChart({
  value,
  benefit,
  endLabel,
  startLabel,
  forecast,
}: Props) {
  const values = getValues(value, benefit, forecast);

  return (
    <>
      <BarChart values={values} css={{ marginBottom: "0rem" }} />
      <FlexContainer justifyContent="space-between">
        {startLabel && (
          <Text size="sm" tag="span" color={theme.color.text.text02}>
            {startLabel}: {value}%
          </Text>
        )}
        {endLabel && (
          <Text size="sm" tag="span" color={theme.color.text.text02}>
            {endLabel}
          </Text>
        )}
      </FlexContainer>
    </>
  );
}
